// Français pour l'éditeur de decks (onglet Decks). Enregistré au chargement. Vocabulaire
// aligné sur le glossaire du registre : deliverable → livrable, slide → diapositive. Le texte
// du DOCUMENT dans les aperçus est figé (golden master allemand) et ne passe jamais par ici —
// ce catalogue ne couvre que l'interface opérateur.
import { registerFr } from '../../i18n/index.js';

registerFr({
  'The image starts here; the text column ends 36 px before it.': 'L’image commence ici ; la colonne de texte s’arrête 36 px avant.',
  'Remove this image from the picker': 'Retirer cette image du sélecteur',
  'The image could not be restored.': 'L’image n’a pas pu être rétablie.',
  '{n} hidden': '{n} masquée(s)',
  'Drag to move · zoom': 'Glisser pour déplacer · zoom',
  'Reset': 'Réinitialiser',
  'Split: text + image': 'Split : texte + image',
  'Split position': 'Position du split',
  'Image side': 'Côté de l’image',
  'right': 'droite',
  'left': 'gauche',
  'Focal point x': 'Point focal x',
  'Focal point y': 'Point focal y',
  'Zoom': 'Zoom',
  'Remove slide': 'Retirer la diapositive',
  'Add after this slide': 'Insérer après cette diapositive',
  'Remove': 'Retirer',
  'Remove «{name}» from this deck? Its slot texts are lost; the register data stays.': 'Retirer « {name} » de ce deck ? Les textes des slots sont perdus, les données du registre restent.',
  'Delete this image': 'Supprimer cette image',
  'Upload an image (PNG or JPEG)': 'Téléverser une image (PNG ou JPEG)',
  'The image could not be uploaded.': 'L’image n’a pas pu être téléversée.',
  'The image could not be deleted.': 'L’image n’a pas pu être supprimée.',
  'Starting point': 'Situation de départ',
  'Section divider': 'Page de section',
  'Annex deliverable register': 'Annexe registre des livrables',
  'First paragraph': 'Premier paragraphe',
  'Second paragraph': 'Deuxième paragraphe',
  'Third paragraph': 'Troisième paragraphe',
  'Phase axis': 'Axe des phases',
  'Result cards': 'Cartes de résultats',
  'Terminal milestones': 'Jalons de la carte finale',
  'Date markers': 'Marqueurs de dates',
  'Short name override': 'Nom court (surcharge)',
  'Due-date note': 'Note d’échéance',
  'Tagline': 'Tagline',
  // ── page / liste ───────────────────────────────────────────────────────────
  'Decks': 'Decks',
  'No engagement selected': 'Aucun mandat sélectionné',
  'Decks belong to one engagement — pick an engagement to see its proposal decks.':
    'Les decks appartiennent à un mandat — choisissez un mandat pour voir ses decks d’offre.',
  'New deck': 'Nouveau deck',
  'Deck title': 'Titre du deck',
  'e.g. “Vorprojekt — Projektplan & Angebot”': 'p. ex. « Avant-projet — Plan et offre »',
  'Create': 'Créer',
  'A new deck starts with the standard 13-slide order — every slide can be toggled off in the editor.':
    'Un nouveau deck démarre avec l’ordre standard de 13 diapositives — chacune peut être désactivée dans l’éditeur.',
  'Could not load the decks': 'Impossible de charger les decks',
  'No decks yet': 'Pas encore de deck',
  'A deck is this engagement’s proposal document — slides bound live to the register.':
    'Un deck est le document d’offre de ce mandat — ses diapositives sont liées en direct au registre.',
  'The deck could not be created.': 'Le deck n’a pas pu être créé.',
  'final': 'final',
  'archived': 'archivé',

  // ── en-tête de l'éditeur ───────────────────────────────────────────────────
  '{n} slides': '{n} diapositives',
  'Back to decks': 'Retour aux decks',
  'Export PPTX': 'Exporter le PPTX',
  'Download v{n}': 'Télécharger v{n}',
  'Version v{n} exported': 'Version v{n} exportée',
  'The export failed — nothing was written.': 'L’export a échoué — rien n’a été écrit.',
  'Could not load the deck': 'Impossible de charger le deck',
  'The slide could not be saved.': 'La diapositive n’a pas pu être enregistrée.',
  'No slides in this deck': 'Aucune diapositive dans ce deck',
  'A deck is created with the standard 13-slide order — this one has none.':
    'Un deck est créé avec l’ordre standard de 13 diapositives — celui-ci n’en a aucune.',

  // ── rail / scène ───────────────────────────────────────────────────────────
  'Move up': 'Monter',
  'Move down': 'Descendre',
  'Included': 'Incluse',
  'This slide paginates into {n} pages from the register data.':
    'Cette diapositive se pagine en {n} pages à partir des données du registre.',

  // ── panneau des slots ──────────────────────────────────────────────────────
  'Slots': 'Slots',
  'Over budget — not saved. Shorten the marked slots.':
    'Budget dépassé — non enregistré. Raccourcissez les slots marqués.',
  'One entry per line': 'Une entrée par ligne',
  'No image': 'Aucune image',
  'Add entry': 'Ajouter une entrée',
  'Refs, comma-separated — e.g. REQ-050': 'Réfs, séparées par des virgules — p. ex. REQ-050',
  'No mandate references in the library yet.': 'Pas encore de références de mandat dans la bibliothèque.',

  // le bloc lié au registre
  'From the register': 'Depuis le registre',
  'This block is filled live from the register — edit deliverables, requirements and dates there.':
    'Ce bloc est rempli en direct depuis le registre — les livrables, exigences et échéances s’y éditent.',
  '{n} deliverables on the time track': '{n} livrables sur l’axe temporel',
  '{n} deliverables across {p} pages': '{n} livrables sur {p} pages',
  '{r} requirements · {d} deliverables · {e} edges': '{r} exigences · {d} livrables · {e} liens',
  '{n} reference cards selected': '{n} cartes de référence sélectionnées',
  '{n} people from the library': '{n} personnes de la bibliothèque',
  '{n} requirements across {p} pages': '{n} exigences sur {p} pages',
  'Loading register data …': 'Chargement des données du registre …',
  'No register data yet for this slide.': 'Pas encore de données du registre pour cette diapositive.',

  // ── noms des types de diapositives (catalogue) ─────────────────────────────
  'Cover': 'Couverture',
  'Mandate (split)': 'Mandat (split)',
  'Target picture & timeline': 'Vision cible & calendrier',
  'Work packages (Gantt)': 'Lots de travaux (Gantt)',
  'Deliverables table': 'Tableau des livrables',
  'Traceability mesh': 'Maillage de traçabilité',
  'Reference cards': 'Cartes de référence',
  'Team': 'Équipe',
  'Investment': 'Investissement',
  'Next steps (split)': 'Prochaines étapes (split)',
  'Annex divider': 'Intercalaire d’annexe',
  'Annex register': 'Registre en annexe',
  'Back cover': 'Quatrième de couverture',

  // ── libellés des slots (catalogue) ─────────────────────────────────────────
  'Eyebrow': 'Surtitre',
  'Title': 'Titre',
  'Subtitle': 'Sous-titre',
  'Client name': 'Nom du client',
  'Date label': 'Ligne de date',
  'Hero image': 'Image héro',
  'Body': 'Texte courant',
  'Image': 'Image',
  'Intro': 'Introduction',
  'Timeline items': 'Étapes du calendrier',
  'Terminal note': 'Ligne de clôture',
  'Phase legend': 'Légende des phases',
  'Acceptance summary override': 'Critères d’acceptation (résumé, override)',
  'Subtitle override': 'Sous-titre (override)',
  'Footer note': 'Ligne de pied',
  'Claims': 'Affirmations',
  'Highlighted requirements': 'Exigences mises en évidence',
  'Legend': 'Légende',
  'References': 'Références',
  'Takeaway override': 'Takeaway (override)',
  'Footer line': 'Ligne de clôture (serif)',
  'Third parties': 'Parties tierces',
  'People': 'Personnes',
  'Months': 'Mois',
  'Days per month': 'Jours par mois',
  'Utilisation %': 'Taux d’occupation %',
  'Day rate (CHF)': 'Taux journalier (CHF)',
  'Discounts': 'Rabais',
  'Budget label': 'Ligne de budget',
  'Steps': 'Étapes',
  'Footer': 'Pied (mono)',
  'Label': 'Libellé',
  'Contact lines': 'Lignes de contact',
  'Note': 'Note',
  'Page titles': 'Titres de page',
  'Descoped note': 'Ligne des exigences hors périmètre',

  // libellés des champs d'entrée
  'Name': 'Nom',
  'Person': 'Personne',
  'Profile context': 'Contexte de profil',
  'Percent': 'Pour cent',
  'Category': 'Catégorie',
}, 'DecksPage');
